class HeaderBanner extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'scroll', this.handleScroll.bind(this))
  }

  handleScroll () {
    this.previousHasScrolled = this.hasScrolled
    const hasScrolled = window.pageYOffset > this.scrollOffset

    if (this.previousHasScrolled === hasScrolled) return
    this.hasScrolled = hasScrolled
  }

  get hasScrolled () {
    return this._hasScrolled
  }

  set hasScrolled (hasScrolled) {
    this._hasScrolled = hasScrolled

    this.toggleAttribute(this.scrolledAttribute, hasScrolled)

    window.BAO.dispatchEvent(window.BAO.EVENTS.HEADER.SCROLLED, {
      hasScrolled,
    })
  }

  get scrollOffset () {
    return 20
  }

  get scrolledAttribute () {
    return 'scrolled'
  }
}

if (!customElements.get('header-banner')) {
  customElements.define('header-banner', HeaderBanner)
}
